import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  input,
  Output,
} from '@angular/core';

import { UserAuthService } from '../services/user-auth.service';
import { UserStateService } from '../services/user-state.service';
import { ModalService } from 'src/app/components/modals/modal.service';

@Directive({
  selector: '[signOutButton]',
  standalone: false,
})
export class SignOutButtonDirective {
  @Input() signOutButton = { broadcast: true, forceConfirmation: false };
  @Output() signedOut = new EventEmitter<boolean>();

  constructor(
    private userStateService: UserStateService,
    private userAuthService: UserAuthService,
    private modalService: ModalService,
  ) {}

  _signOut() {
    this.userAuthService
      .signOut(this.signOutButton.broadcast)
      .then(() => {
        console.debug('User signed out.');
        this.signedOut.emit(true);
      })
      .catch((err) => {
        console.debug('User sign out failed', err);
        this.signedOut.emit(false);
      });
  }

  logout() {
    if (this.userStateService.isRiseAuthUser()) {
      if (this.signOutButton.forceConfirmation) {
        return this.modalService
          .confirm(
            'Sign Out of Rise Vision',
            'Are you sure you want to sign out?',
            'Sign Out',
            'Cancel',
          )
          .then(() => {
            this._signOut();
          })
          .catch(() => {});
      } else {
        this._signOut();
      }
    } else {
      return this.modalService
        .confirm(
          'Sign Out of Rise Vision',
          'Signing out does not sign you out of your Google Account. If you are on a shared computer you should sign out of your Google Account.',
          'Sign Out',
          'Cancel',
        )
        .then(() => {
          this._signOut();
        })
        .catch(() => {});
    }
  }

  @HostListener('click') onClick() {
    this.logout();
  }
}
